import React from 'react';
import { View } from 'react-native';
import { DismissibleModal } from '@/components/ui/dismissible-modal';
import { Text } from '@/components/ui/text';
import { usePolicySoftPrompt } from '../hooks/use-policy-soft-prompt';

export function PolicySoftPrompt() {
  const softPrompt = usePolicySoftPrompt();

  if (!softPrompt.isVisible) return null;

  return (
    <DismissibleModal
      visible={true}
      onClose={softPrompt.dismiss}
      title="Policy Updated"
      testID="policy-soft-prompt-modal"
    >
      <View>
        <Text className="text-card-foreground text-sm">
          We have updated our policies. You can review the changes in your settings.
        </Text>
      </View>
    </DismissibleModal>
  );
}
